var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Offer, Product, Tariff, } from "../../schema";
import { findOneByComponentSet } from "../offers";
import { getOptions } from "@api/utils";
import { findOneById, findOneStandard } from "../tariff";
import { ProductsService } from "../products";
import { Storage } from "../../core/storage";
import { getQueryParams, getsubscriptionTypes } from "../../utils";
import { CachableRequest } from "../../core";
import { TrackingOrderView } from "../tracking";
import { BasketAssistant } from "../basket";
import config from "@api/config";
var Configurator = /*@__PURE__*/ (function () {
    function Configurator() {
    }
    Object.defineProperty(Configurator, "storage", {
        get: function () {
            return Storage.getHelper();
        },
        enumerable: true,
        configurable: true
    });
    Configurator.stopEventListeners = function () {
        this.eventListenersPaused = true;
    };
    Configurator.resumeEventListeners = function () {
        this.eventListenersPaused = false;
    };
    Configurator.setOffer = function (offer) {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Configurator.previousOffer === offer &&
                            Configurator.offer === offer) {
                            return [2 /*return*/];
                        }
                        Configurator.previousOffer = Configurator.offer;
                        Configurator.offer = offer;
                        Configurator.offer.subscribe("change", function (old, current) {
                            Configurator.handleOfferChanged(old, current);
                        });
                        Configurator.handleTracking();
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.offer = offer.toJSON();
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.setSubTariffIds = function (subTariffIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, eventListener;
            return __generator(this, function (_b) {
                Configurator.subTariffIds = subTariffIds;
                if (Configurator.eventListeners.subTariffIdsSet) {
                    for (_i = 0, _a = Configurator.eventListeners
                        .subTariffIdsSet; _i < _a.length; _i++) {
                        eventListener = _a[_i];
                        eventListener(subTariffIds);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Configurator.setTariff = function (tariff, subTariff, withOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator, e_1, _i, _a, eventListener;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Configurator.tariff = tariff;
                        Configurator.subTariff = subTariff ? subTariff : null;
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _b.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.tariff = tariff.toJSON();
                        if (subTariff)
                            storedConfigurator.subTariff = subTariff.toJSON();
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        if (Configurator.eventListeners.tariffAdded) {
                            for (_i = 0, _a = Configurator.eventListeners
                                .tariffAdded; _i < _a.length; _i++) {
                                eventListener = _a[_i];
                                eventListener(Configurator.tariff);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.setAmount = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            var totalBasketAmount, storedConfigurator, previousOptions, e_2, _i, _a, eventListener;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (amount === Configurator.amount) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, BasketAssistant.getTotalAmount()];
                    case 1:
                        totalBasketAmount = _b.sent();
                        if (totalBasketAmount + amount > BasketAssistant.MAX_ITEMS_ALLOWED) {
                            return [2 /*return*/];
                        }
                        Configurator.previousAmount = Configurator.amount;
                        Configurator.amount = amount;
                        this.handleTracking();
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 2:
                        storedConfigurator = _b.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.amount = amount;
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        previousOptions = null;
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _b.sent();
                        // do nothing for now
                        console.log(e_2);
                        return [3 /*break*/, 7];
                    case 7:
                        if (Configurator.eventListeners.amountChanged) {
                            for (_i = 0, _a = Configurator.eventListeners
                                .amountChanged; _i < _a.length; _i++) {
                                eventListener = _a[_i];
                                eventListener(Configurator.amount);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.unsetTariff = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Configurator.tariff = null;
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.tariff = null;
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.unsetProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Configurator.product = null;
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.product = null;
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.setCoPaymentState = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Configurator.coPaymentState = state;
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.coPaymentState = state;
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.setProduct = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            var storedConfigurator, e_3, e_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Configurator.product = product;
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.product = product.toJSON();
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        product.subscribe("change", function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!Configurator.getOffer()) {
                                                return [2 /*return*/];
                                            }
                                            return [4 /*yield*/, Configurator.calculateOffer()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 10]);
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 10];
                    case 5:
                        e_3 = _a.sent();
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        e_4 = _a.sent();
                        console.log(e_4);
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Configurator.hasDeviceDetailModule = function () {
        return window.eShopWidgets.reduce(function (acc, current) {
            return current.includes("device-detail") || acc;
        }, false);
    };
    Configurator.findAvailableOptions = function (usedOptions, optionsAvailableForTariff) {
        var optionsAvailable = [];
        usedOptions.forEach(function (optionId) {
            var availableOpt = optionsAvailableForTariff.find(function (availableOpt) {
                return availableOpt.id == optionId;
            });
            availableOpt && optionsAvailable.push(availableOpt);
        });
        return optionsAvailable;
    };
    Configurator.calculateOfferForTariff = function (tariffId) {
        return __awaiter(this, void 0, void 0, function () {
            var tariff, offer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, findOneById(tariffId)];
                    case 1:
                        tariff = _a.sent();
                        return [4 /*yield*/, this.calculateOffer(tariff, true)];
                    case 2:
                        offer = _a.sent();
                        return [2 /*return*/, offer];
                }
            });
        });
    };
    Configurator.calculateOffer = function (tariff, doNotSetTariff) {
        return __awaiter(this, void 0, void 0, function () {
            var components, subscriptionTypes, offer, _i, _a, component, _b, _c, _d, tariff_1, _e, defaultTariff, offer, optionsAvailableForTariff, optionsToUse, e_5;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!window.eShopWidgets)
                            return [2 /*return*/];
                        components = [];
                        subscriptionTypes = getsubscriptionTypes();
                        if (!tariff)
                            return [3 /*break*/, 7];
                        if (!!tariff.type)
                            return [3 /*break*/, 5];
                        offer = tariff;
                        _i = 0, _a = offer.components;
                        _f.label = 1;
                    case 1:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 4];
                        component = _a[_i];
                        if (!(component.type === "tariffMobile"))
                            return [3 /*break*/, 3];
                        _c = (_b = components).push;
                        _d = Tariff.bind;
                        return [4 /*yield*/, findOneById(component.subId
                                ? component.subId
                                : component.refId)];
                    case 2:
                        _c.apply(_b, [new (_d.apply(Tariff, [void 0, _f.sent()]))()]);
                        _f.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        components.push(tariff);
                        _f.label = 6;
                    case 6: return [3 /*break*/, 16];
                    case 7:
                        if (!(Configurator.tariff &&
                            subscriptionTypes.includes(Configurator.tariff.subscriptionType)))
                            return [3 /*break*/, 13];
                        return [4 /*yield*/, Configurator.getCoPaymentState()];
                    case 8:
                        if (!((_f.sent()) ===
                            1 /* TOGGLE_ON */ && this.hasDeviceDetailModule()))
                            return [3 /*break*/, 10];
                        return [4 /*yield*/, Configurator.subTariff];
                    case 9:
                        _e = _f.sent();
                        return [3 /*break*/, 12];
                    case 10: return [4 /*yield*/, Configurator.tariff];
                    case 11:
                        _e = _f.sent();
                        _f.label = 12;
                    case 12:
                        tariff_1 = _e;
                        components.push(tariff_1);
                        return [3 /*break*/, 16];
                    case 13: return [4 /*yield*/, findOneStandard()];
                    case 14:
                        defaultTariff = _f.sent();
                        components.push(defaultTariff);
                        Configurator.tariff = defaultTariff;
                        return [4 /*yield*/, Configurator.setTariff(defaultTariff)];
                    case 15:
                        _f.sent();
                        _f.label = 16;
                    case 16:
                        // -------------------
                        if (Configurator.product && this.hasDeviceDetailModule()) {
                            components.push(Configurator.product);
                        }
                        else {
                            Configurator.removeProduct();
                        }
                        if (!!Configurator.amount)
                            return [3 /*break*/, 18];
                        return [4 /*yield*/, Configurator.setAmount(0)];
                    case 17:
                        _f.sent();
                        _f.label = 18;
                    case 18:
                        _f.trys.push([18, 23, , 24]);
                        return [4 /*yield*/, findOneByComponentSet(components)];
                    case 19:
                        offer = _f.sent();
                        if (Configurator.optionsSelected.size > 0) {
                            optionsAvailableForTariff = getOptions(offer);
                            optionsToUse = Configurator.findAvailableOptions(Configurator.optionsSelected, optionsAvailableForTariff);
                            offer = offer.setUsedOptions(optionsToUse);
                        }
                        else {
                            offer = offer.setUsedOptions([]);
                        }
                        if (!!doNotSetTariff)
                            return [3 /*break*/, 22];
                        return [4 /*yield*/, Configurator.setOffer(offer)];
                    case 20:
                        _f.sent();
                        return [4 /*yield*/, Configurator.handleOfferChanged()];
                    case 21:
                        _f.sent();
                        _f.label = 22;
                    case 22: return [2 /*return*/, offer];
                    case 23:
                        e_5 = _f.sent();
                        // no offer found, doing nothing
                        console.log(e_5, components);
                        return [2 /*return*/, null];
                    case 24: return [2 /*return*/];
                }
            });
        });
    };
    Configurator.getSubTariffIds = function () {
        return Configurator.subTariffIds;
    };
    Configurator.getCoPaymentState = function () {
        return Configurator.coPaymentState;
    };
    Configurator.getOffer = function () {
        return Configurator.offer;
    };
    Configurator.getTariff = function () {
        return Configurator.tariff;
    };
    Configurator.getSubTariff = function () {
        return Configurator.subTariff;
    };
    Configurator.getProduct = function () {
        return Configurator.product;
    };
    Configurator.getAmount = function () {
        if (config.CBU_CHECKOUT_TARIFF_IDS.includes(this.getTariff().id)) {
            return 1;
        }
        return Configurator.amount ? Configurator.amount : 1;
    };
    Configurator.removeOffer = function () {
        Configurator.offer = null;
    };
    Configurator.removeTariff = function () {
        Configurator.tariff = null;
    };
    Configurator.removeProduct = function () {
        Configurator.product = null;
    };
    Configurator.subscribe = function (event, listener) {
        if (Configurator.eventListeners[event]) {
            Configurator.eventListeners[event].push(listener);
        }
    };
    Configurator.handleOfferChanged = function (old, current) {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, eventListener, storedConfigurator;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        old &&
                            current &&
                            old.usedOptions.length > current.usedOptions.length &&
                            this.onOptionCancelled(old.usedOptions, current.usedOptions);
                        old &&
                            current &&
                            old.usedOptions.length < current.usedOptions.length &&
                            this.onOptionAdded(old.usedOptions, current.usedOptions);
                        if (!!this.eventListenersPaused)
                            return [3 /*break*/, 3];
                        if (Configurator.eventListeners.offerChanged) {
                            _loop_1 = function (eventListener) {
                                if (Configurator.getOffer()) {
                                    if (Configurator.eventListenerTimeouts.offerChanged[eventListener]) {
                                        clearTimeout(Configurator.eventListenerTimeouts.offerChanged[eventListener]);
                                    }
                                    Configurator.eventListenerTimeouts.offerChanged[eventListener] = setTimeout(function () {
                                        Configurator.eventListeners.offerChanged[eventListener](Configurator.getOffer());
                                    }, 1);
                                }
                            };
                            for (eventListener in Configurator.eventListeners
                                .offerChanged) {
                                _loop_1(eventListener);
                            }
                        }
                        return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                    case 1:
                        storedConfigurator = _a.sent();
                        if (storedConfigurator === null) {
                            storedConfigurator = {};
                        }
                        storedConfigurator.offer = Configurator.offer.toJSON();
                        return [4 /*yield*/, Configurator.storage.setItem("configurator", {})];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Configurator.onOptionCancelled = function (oldUsedOptions, currentUsedOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var optsToDelete;
            var _this = this;
            return __generator(this, function (_a) {
                optsToDelete = [];
                oldUsedOptions.forEach(function (oldOpt) {
                    return currentUsedOptions.findIndex(function (currentOpt) { return oldOpt.id === currentOpt.id; }) === -1 && optsToDelete.push(oldOpt.id);
                });
                optsToDelete.forEach(function (optId) { return _this.optionsSelected.delete(optId); });
                return [2 /*return*/];
            });
        });
    };
    Configurator.onOptionAdded = function (oldUsedOptions, currentUsedOptions) {
        var _this = this;
        var optsToAdd = [];
        currentUsedOptions.forEach(function (currentOpt) {
            return oldUsedOptions.findIndex(function (oldOpt) { return oldOpt.id === currentOpt.id; }) === -1 && optsToAdd.push(currentOpt.id);
        });
        optsToAdd.forEach(function (optId) { return _this.optionsSelected.add(optId); });
    };
    Configurator.hasExternalProduct = function () {
        return Configurator.usesExternalProduct;
    };
    Configurator.hasExternalTariff = function () {
        return Configurator.usesExternalTariff;
    };
    Configurator.sync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Configurator.syncing)
                            return [3 /*break*/, 2];
                        return [4 /*yield*/, Configurator.syncing.getResponse()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        Configurator.offer = new Offer();
                        Configurator.syncing = new CachableRequest(function () {
                            return __awaiter(_this, void 0, void 0, function () {
                                var params, storedConfigurator, previousOptions, hasParams, tariffId, tariff, e_6, productId, product, e_7, tariff, subTariff, product, offer;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            params = getQueryParams(document.location.search);
                                            return [4 /*yield*/, Configurator.storage.getItem("configurator")];
                                        case 1:
                                            storedConfigurator = _a.sent();
                                            if (!storedConfigurator) {
                                                storedConfigurator = {};
                                            }
                                            previousOptions = null;
                                            hasParams = params.t || params.p || params.s;
                                            if (!hasParams)
                                                return [3 /*break*/, 12];
                                            if (!params.t)
                                                return [3 /*break*/, 6];
                                            tariffId = parseInt(params.t, 10);
                                            _a.label = 2;
                                        case 2:
                                            _a.trys.push([2, 5, , 6]);
                                            return [4 /*yield*/, findOneById(tariffId)];
                                        case 3:
                                            tariff = _a.sent();
                                            return [4 /*yield*/, Configurator.setTariff(tariff)];
                                        case 4:
                                            _a.sent();
                                            Configurator.usesExternalTariff = true;
                                            return [3 /*break*/, 6];
                                        case 5:
                                            e_6 = _a.sent();
                                            // invalid tariff id
                                            console.log("Invalid tariff id");
                                            return [3 /*break*/, 6];
                                        case 6:
                                            if (!params.p)
                                                return [3 /*break*/, 11];
                                            productId = parseInt(params.p, 10);
                                            _a.label = 7;
                                        case 7:
                                            _a.trys.push([7, 10, , 11]);
                                            return [4 /*yield*/, ProductsService.findOneById(productId)];
                                        case 8:
                                            product = _a.sent();
                                            return [4 /*yield*/, Configurator.setProduct(product)];
                                        case 9:
                                            _a.sent();
                                            Configurator.usesExternalProduct = true;
                                            return [3 /*break*/, 11];
                                        case 10:
                                            e_7 = _a.sent();
                                            // invalid product id
                                            console.log("Invalid product id");
                                            return [3 /*break*/, 11];
                                        case 11: return [3 /*break*/, 13];
                                        case 12:
                                            // stored Configurator
                                            if (storedConfigurator.amount) {
                                                Configurator.amount = storedConfigurator.amount;
                                            }
                                            if (storedConfigurator.coPaymentState != null) {
                                                Configurator.coPaymentState =
                                                    storedConfigurator.coPaymentState;
                                            }
                                            if (storedConfigurator.tariff) {
                                                tariff = new Tariff();
                                                tariff.loadJSON(storedConfigurator.tariff);
                                                Configurator.tariff = tariff;
                                            }
                                            if (storedConfigurator.subTariff) {
                                                subTariff = new Tariff();
                                                subTariff.loadJSON(storedConfigurator.subTariff);
                                                Configurator.subTariff = subTariff;
                                            }
                                            if (storedConfigurator.product) {
                                                product = new Product();
                                                product.loadJSON(storedConfigurator.product);
                                                Configurator.product = product;
                                                Configurator.product.subscribe("change", function () {
                                                    return __awaiter(_this, void 0, void 0, function () {
                                                        return __generator(this, function (_a) {
                                                            return [2 /*return*/, this.handleProductOfferChanged()];
                                                        });
                                                    });
                                                });
                                            }
                                            _a.label = 13;
                                        case 13:
                                            if (!storedConfigurator.offer)
                                                return [3 /*break*/, 15];
                                            offer = Configurator.offer
                                                ? Configurator.offer
                                                : new Offer();
                                            offer.loadJSON(storedConfigurator.offer);
                                            Configurator.offer = offer;
                                            Configurator.offer.subscribe("change", Configurator.calculateOffer);
                                            offer.usedOptions.forEach(function (opt) {
                                                return Configurator.optionsSelected.add(opt.id);
                                            });
                                            return [4 /*yield*/, Configurator.handleOfferChanged()];
                                        case 14:
                                            _a.sent();
                                            _a.label = 15;
                                        case 15: return [4 /*yield*/, Configurator.calculateOffer()];
                                        case 16:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [4 /*yield*/, Configurator.syncing.getResponse()];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Configurator.handleProductOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var previousOptions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Configurator.getOffer()) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Configurator.calculateOffer()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Configurator.handleTracking = function () {
        var _this = this;
        var timeoutDuration = 2000;
        if (!Configurator.initialTrackingCompleted) {
            timeoutDuration = 2500;
        }
        if (Configurator.isTracking) {
            return;
        }
        clearTimeout(Configurator.trackingTimeout);
        Configurator.trackingTimeout = setTimeout(function () {
            return __awaiter(_this, void 0, void 0, function () {
                var orderViewTracking;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            Configurator.isTracking = true;
                            setTimeout(function () {
                                if (Configurator.isTracking) {
                                    Configurator.isTracking = false;
                                    Configurator.initialTrackingCompleted = true;
                                }
                            }, timeoutDuration);
                            orderViewTracking = new TrackingOrderView();
                            if (!!Configurator.previousOffer)
                                return [3 /*break*/, 2];
                            return [4 /*yield*/, orderViewTracking.track()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            if (!(Configurator.previousOffer.id !== Configurator.offer.id ||
                                Configurator.previousAmount !== Configurator.amount))
                                return [3 /*break*/, 4];
                            return [4 /*yield*/, orderViewTracking.track()];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            Configurator.initialTrackingCompleted = true;
                            Configurator.isTracking = false;
                            return [2 /*return*/];
                    }
                });
            });
        }, timeoutDuration);
    };
    Configurator.tariffUsesCbuCheckout = function (tariffId) {
        if (config.CBU_CHECKOUT_TARIFF_IDS.includes(parseInt(tariffId)))
            return true;
    };
    Configurator.optionsSelected = new Set([]);
    Configurator.previousAmount = 0;
    Configurator.initialTrackingCompleted = false;
    Configurator.isTracking = false;
    Configurator.eventListenersPaused = false;
    Configurator.eventListeners = {
        offerChanged: [],
        amountChanged: [],
        subTariffIdsSet: [],
    };
    Configurator.eventListenerTimeouts = {
        offerChanged: {},
        amountChanged: {},
    };
    return Configurator;
}());
export { Configurator };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/configurator/configurator.ts
// module id = null
// module chunks = 